import {ActivityStatus, IActivity} from "./activity";
import {TypeUtils} from '../shared/utils/type-utils';

export class ActivityMapper {

  public static map(data: any): IActivity {
    const activity: IActivity = <IActivity>{};

    activity.id = activity.id = data.id || (data._id && data._id.$oid) || '';
    activity.websiteId = parseInt(data.domain_id);
    activity.service = data.service;
    activity.type = data.type;
    activity.action = data.action;
    activity.date = data.created_at ? new Date(data.created_at) : new Date();
    activity.status = data.status;
    activity.progress = [ActivityStatus.DONE, ActivityStatus.FAILED].includes(data.status) ? 100 : (TypeUtils.isString(data.progress) ? ( !TypeUtils.isEmpty(data.progress) ? parseInt(data.progress) : 0) : (TypeUtils.isUndefined(data.progress) ? 0 : data.progress));
    activity.message = data.message || '';
    activity.meta = data.meta_data ? (typeof data.meta_data === 'string' ? JSON.parse(data.meta_data) : data.meta_data) : (data.meta ? (typeof data.meta === 'string' ? JSON.parse(data.meta) : data.meta) : null);

    return activity;
  }

}
